import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiArrowUpRight, FiCheck } = FiIcons;
const plans = [
  { name: 'Open gym', price: '$49', unit: '/ week', description: 'Your routine, your way.', features: ['Full gym access', 'Locker room & amenities', 'Member community'], featured: false },
  { name: 'All access', price: '$69', unit: '/ week', description: 'A little more of everything.', features: ['Unlimited group classes', 'Full gym access', 'Recovery zone access'], featured: true },
  { name: 'Coached', price: '$99', unit: '/ week', description: 'Guidance built around you.', features: ['Everything in All access', 'Monthly coach check-in', 'Personalised training plan'], featured: false },
];

function Membership() {
  return (
    <section className="membership-section" id="memberships">
      <div className="section-head">
        <div>
          <span className="eyebrow">Simple, like it should be</span>
          <h2>Pick your pace.<br /><em>We'll meet you there.</em></h2>
        </div>
        <p>Clear options, no long-term lock-in. Every membership comes with a proper welcome and a team in your corner.</p>
      </div>
      <div className="plan-grid">
        {plans.map((plan) => (
          <article className={plan.featured ? 'plan-card plan-featured' : 'plan-card'} key={plan.name}>
            {plan.featured && <span className="popular-label">MEMBER FAVOURITE</span>}
            <span className="plan-name">{plan.name}</span>
            <p className="plan-description">{plan.description}</p>
            <div className="plan-price"><strong>{plan.price}</strong><span>{plan.unit}</span></div>
            <a
              className={plan.featured ? 'button button-lime plan-button' : 'button button-outline plan-button'}
              href={waLink(`I am interested in the ${plan.name} membership.`)}
              target="_blank"
              rel="noreferrer"
            >
              Explore this plan <SafeIcon icon={FiArrowUpRight} />
            </a>
            <ul>{plan.features.map((f) => <li key={f}><SafeIcon icon={FiCheck} />{f}</li>)}</ul>
          </article>
        ))}
      </div>
      <p className="membership-footnote">
        Not sure where to start?
        <a href={waLink('I need help choosing the right membership.')} target="_blank" rel="noreferrer">Talk to our team <span aria-hidden="true">↗</span></a>
      </p>
    </section>
  );
}
export default Membership;
